import { COST_BREAKDOWN_DECIMAL_PRECISION } from "../../constants"

import type { PurchaseOrderLineWithReceiptContext } from "@/screens/WarehouseReceiving/types"
import { formatNumber } from "@/utils/number"

interface CostBreakdownTotalLaidDownCostCellProps {
  purchaseOrderLine: PurchaseOrderLineWithReceiptContext
}

export const CostBreakdownTotalLaidDownCostCell: React.FC<CostBreakdownTotalLaidDownCostCellProps> = ({
  purchaseOrderLine,
}) => {
  const totalLaidDownCost = purchaseOrderLine.costBreakdown?.totalLaidDownCostPerUom

  if (totalLaidDownCost === null || totalLaidDownCost === undefined) {
    return ""
  }

  return `$${formatNumber(totalLaidDownCost, COST_BREAKDOWN_DECIMAL_PRECISION, COST_BREAKDOWN_DECIMAL_PRECISION)}`
}
